<template>
  <a-modal
    title="购买发送量"
    :visible="visible"
    :centered="true"
    :mask-closable="false"
    :width="580"
    :footer="null"
    wrap-class-name="buy-send-modal"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form
      :form="form"
    >
      <a-form-item
        label="数量："
        :validate-status="validateStatus ? 'error' : ''"
        :help="validateHelp"
      >
        <div
          v-decorator="['radioValue', {
            rules: [{
              required: true
            }],
            initialValue: radioValue
          }]"
        >
          <a-radio-group
            :value="radioValue"
            @change="onChangeNum"
          >
            <a-radio
              v-for="item in plainOptions"
              :key="item.key"
              :value="item.key"
            >
              {{ item.label }}
            </a-radio>
            <a-radio
              :style="radioStyle"
              :value="5"
            >
              <a-input
                :value="input"
                placeholder="自定义数量"
                :style="{ width: 160, marginLeft: 10 }"
                @input="handleInput"
                @focus="handleFocus"
                @blur="checkNum"
              />
              封
            </a-radio>
          </a-radio-group>
        </div>
      </a-form-item>
      <a-form-item
        label="价格："
      >
        <span class="price fs-blue">{{ price }}元</span>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          @click="handleOk"
        >
          立即支付
        </a-button>
      </a-form-item>
    </a-form>
    <!-- 支付提交 -->
    <form
      v-if="isShowForm"
      :id="formId"
      method="post"
      :action="formDatas.posturl"
      target="_blank"
    >
      <input
        v-for="(value, key) in formDatas.data"
        :key="key"
        :name="key"
        type="hidden"
        :value="value"
      >
    </form>
  </a-modal>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      plainOptions: [
        { label: '500封', value: 500, key: 1 },
        { label: '1000封', value: 1000, key: 2 },
        { label: '5000封', value: 5000, key: 3 },
        { label: '10000封', value: 10000, key: 4 }
      ],
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        marginTop: '24px'
      },
      radioValue: 2,
      input: '',
      formData: {
        num: ''
      },
      price: 0,
      validateStatus: '',
      validateHelp: '',
      isShowForm: true,
      formId: Math.random().toString(10).substring(2),
      formDatas: {}
    }
  },

  watch: {
    visible (val) {
      let curr = this.plainOptions.find(item => item.key === 2)
      let num = curr && curr.value
      this.countPrice(num)
    }
  },

  methods: {
    ...mapActions('edm', ['payEmail']),
    onChangeNum (e) {
      let val = e.target.value
      this.radioValue = val

      if (val !== 5) {
        let curr = this.plainOptions.find(item => item.key === val)
        let num = curr && curr.value
        this.countPrice(num)
        this.validateStatus = ''
        this.validateHelp = ''
      } else {
        this.price = '0.00'
      }

      this.input = ''
      this.form.setFieldsValue({
        radioValue: val
      })
    },
    handleInput (e) {
      let val = this.fixNumber(e)
      this.input = val
      this.countPrice(val)
      this.checkNum()
    },
    handleFocus () {
      this.radioValue = 5
      if (this.input === '') {
        this.price = '0.00'
      }
    },
    setNum () {
      let num = 0
      switch (this.radioValue) {
        case 1:
          num = 500
          break
        case 2:
          num = 1000
          break
        case 3:
          num = 5000
          break
        case 4:
          num = 10000
          break
        case 5:
          num = this.input
          break
      }
      return num
    },
    fixNumber ($event) {
      let fix
      let value = $event.target.value
      if (typeof value !== 'number') {
        fix = Number(value.replace(/\D/g, ''))
      } else {
        fix = value
      }
      return fix
    },
    checkNum () {
      if (this.radioValue !== 5) {
        this.validateStatus = ''
        this.validateHelp = ''
      } else if (this.input === '') {
        this.validateStatus = 'error'
        this.validateHelp = '请输入'
      } else if (Number(this.input) < 100) {
        this.validateStatus = 'error'
        this.validateHelp = '不能小于100'
      } else {
        this.validateStatus = ''
        this.validateHelp = ''
      }
    },
    countPrice (val) {
      let num = Number(val)
      this.price = (6 / 100 * num).toFixed(2)
    },
    hide () {
      this.radioValue = 2
      this.input = ''
      this.validateStatus = ''
      this.validateHelp = ''
      this.form.resetFields()
      this.$emit('update:visible', false)
    },
    handleOk () {
      let _this = this
      this.formData.num = this.setNum()
      this.checkNum()
      this.form.validateFields(async (err, values) => {
        if (!err && !this.validateStatus) {
          let chain = await this.payEmail({
            type: 6,
            num: _this.formData.num,
            money: _this.price
          })
          chain.onSuccess(res => {
            if (!res.error && !(res.hasOwnProperty('redirect'))) {
              this.isShowForm = true
              this.formDatas = res
              setTimeout(() => {
                this.hide()
                document.getElementById(this.formId).submit()
                this.isShowForm = false
              }, 1000)
            }
          })
        }
      })
    },
    handleCancel () {
      this.hide()
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .ant-form-item-label {
  float: left;
  width: 118px;
  padding-right: 16px;
  label {
    color: #666;
  }
}
::v-deep .ant-form-item-control-wrapper {
  padding-left: 118px;
}
::v-deep .ant-form-explain {
  padding-left: 24px;
}
.price {
  font-size: 24px;
}
.input-box {
  display: inline-block;
}
</style>
<style lang="scss">
.buy-send-modal {
  .ant-modal-body {
    padding: 32px 0;
  }
}
</style>
